import React from "react";
import classes from "./Header.module.css";
import {Link} from "react-router-dom";


const Header = () => {
    return(
        <div className={classes.NavContainer}>

                <h1 className={classes.MainTitle}>
                    <Link to='/'><span>SUMMIT</span></Link>
                </h1>

        </div>
    )
}

export default Header;